module.exports = __webpack_public_path__ + "static/media/course5.3d58b724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course5.png
// module id = 2845
// module chunks = 0